"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "card-panel"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_global_event = (0, vue_1.resolveComponent)("global-event");
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    return (_ctx.message !== undefined && _ctx.show)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            (0, vue_1.createVNode)(_component_AppButton, {
                size: "big",
                type: "close",
                disableOnServerBusy: false,
                onClick: _ctx.hideMe,
                align: "right"
            }, null, 8, ["onClick"]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.cards, (name) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    id: "log_panel_card",
                    class: "cardbox",
                    key: name
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { name, isSelfReplicatingRobotsCard: _ctx.isSelfReplicatingRobotsCard(name), resources: _ctx.getResourcesOnCard(name) }
                    }, null, 8, ["card"])
                ]));
            }), 128)),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.globalEvents, (name) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    id: "log_panel_card",
                    class: "cardbox",
                    key: name
                }, [
                    (0, vue_1.createVNode)(_component_global_event, {
                        globalEventName: name,
                        type: "prior",
                        showIcons: false
                    }, null, 8, ["globalEventName"])
                ]));
            }), 128)),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.colonies, (name) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    id: "log_panel_card",
                    class: "cardbox",
                    key: name
                }, [
                    (0, vue_1.createVNode)(_component_colony, {
                        colony: _ctx.getColony(name)
                    }, null, 8, ["colony"])
                ]));
            }), 128))
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
